var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuctions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 36,
    viewBox: "0 0 57 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.8735 18.8774C44.7694 15.3598 35.2167 15.015 28.4229 17.8429L25.526 16.153C26.0088 15.7737 25.9054 15.2909 25.0432 14.7736C24.6294 14.5322 23.7672 14.1183 22.2843 13.8424C18.1459 10.3938 13.0075 7.49694 7.73105 5.60019C7.00684 4.22073 1.97183 3.46204 0.385455 4.35868C-0.511191 4.87598 0.213023 5.63468 1.97183 6.15197C2.7995 7.22105 5.28252 9.8765 15.5939 14.4632C15.1456 15.2909 17.2493 16.2565 19.9047 16.6358L25.0432 19.6706C19.5599 23.6021 19.9737 29.3958 26.2847 33.0513C33.0785 36.9828 44.0797 36.9828 50.839 33.0513C57.6328 29.1199 57.6328 22.7744 50.8735 18.8774Z",
    fill: "#685643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4933 24.3263C56.3209 31.9478 48.4925 34.1894 46.0784 34.6722C37.1465 36.5345 29.8353 33.9825 26.5591 30.6028C24.0416 28.0508 23.9727 25.1885 23.9727 24.2573C23.9727 26.6369 25.559 29.0854 28.7663 30.9132C35.1462 34.6032 45.4232 34.6032 51.7687 30.9132C54.9069 29.0854 56.4588 26.7059 56.4933 24.3263Z",
    fill: "url(#paint0_linear_8389_16253)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7687 30.3611C45.4232 34.0511 35.1462 34.0511 28.7663 30.3611C25.559 28.4988 23.9727 26.0848 23.9727 23.6362V24.188C23.9727 26.6021 25.559 29.0506 28.7663 30.9129C35.1462 34.6029 45.4232 34.6029 51.7687 30.9129C54.9069 29.0851 56.4933 26.7055 56.4933 24.2915V23.7397C56.4588 26.1537 54.9069 28.5333 51.7687 30.3611Z",
    fill: "url(#paint1_linear_8389_16253)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0783 15.2563C42.905 10.9455 34.7662 13.1182 33.2143 13.601C27.1792 15.4633 24.0754 18.8429 23.9375 23.671C23.9375 26.0851 25.5239 28.5336 28.7311 30.3959C35.1111 34.0859 45.388 34.0859 51.7335 30.3959C54.8718 28.5681 56.4582 26.1885 56.4582 23.7745C56.4237 19.1533 53.6648 16.8427 51.0783 15.2563Z",
    fill: "url(#paint2_linear_8389_16253)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.0085 31.4998C50.0435 30.5342 51.9748 28.9133 51.7678 28.396C51.5264 27.7408 49.7676 29.8445 43.9739 30.6721C40.1114 31.2239 37.2836 30.7411 37.2146 31.2239C37.0766 31.9136 40.8701 32.293 45.0085 31.4998Z",
    fill: "#617AF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8027 15.3248C56.6999 18.7389 56.7344 24.2223 50.8717 27.6364C45.009 31.0506 35.4908 31.0506 29.6281 27.6364C23.7309 24.2223 23.6965 18.7044 29.5591 15.3248C35.4218 11.9106 44.9401 11.9106 50.8027 15.3248Z",
    fill: "url(#paint3_linear_8389_16253)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.2492 16.6012C34.3871 16.1184 33.4215 15.7045 32.3869 15.4286C32.0765 15.0838 31.8351 14.7044 31.6627 14.3251C37.1115 12.1179 44.5261 12.2559 49.7335 14.7389V17.015C49.7335 17.015 49.699 17.015 49.699 17.0495C45.7676 19.3256 39.5256 19.4635 35.2837 17.4978V16.6356C35.2492 16.6012 35.2492 16.6012 35.2492 16.6012ZM34.3871 17.0495C33.5249 16.5667 32.8697 16.0149 32.3524 15.4286C31.6627 15.2217 30.9384 15.0838 30.2142 14.9803C29.9728 15.0838 29.7659 15.2217 29.559 15.3252C23.9377 18.5669 23.7653 23.7743 28.9382 27.1885C31.2488 27.016 33.4904 26.4298 35.2492 25.4297C35.2492 25.4297 35.2837 25.4297 35.2837 25.3952V17.4978C34.9734 17.3599 34.663 17.1874 34.3871 17.0495Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.244355 3.42761C-0.548832 0.806642 2.6584 -1.26254 4.9345 0.910106C4.96899 0.944592 5.00348 1.01356 5.03796 1.04805L3.9344 5.25539C2.38251 5.84165 0.727164 5.01398 0.244355 3.42761Z",
    fill: "url(#paint4_radial_8389_16253)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10843 5.15171C2.90151 5.01377 2.72908 4.73788 2.62562 4.39301C2.34973 3.39291 2.69459 1.94448 3.45329 1.1513C3.72919 0.875406 4.00508 0.702973 4.28097 0.702973C9.07457 0.25465 15.489 1.77205 22.3518 5.04826L20.9724 10.2902C9.55738 9.46251 4.6948 6.22079 3.10843 5.15171Z",
    fill: "url(#paint5_linear_8389_16253)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8657 10.152C27.3142 7.97937 26.4175 5.08251 24.1414 4.49624C23.4862 4.32381 22.1757 4.22035 20.9687 5.42738C20.8997 5.49635 20.7962 5.6343 20.7273 5.70327C20.072 6.53094 19.7272 7.84142 19.8996 8.87601C20.4859 12.1867 24.2794 12.5316 25.8657 10.152Z",
    fill: "url(#paint6_radial_8389_16253)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 10.8081C24.1449 10.7046 23.869 10.4287 23.7311 9.91141C23.4552 8.9113 23.8001 7.46288 24.5588 6.70418C24.9381 6.32483 25.352 6.18688 25.6623 6.25586L37.4912 9.35963C37.1463 9.25617 36.7325 9.39411 36.3876 9.80795C35.6289 10.5666 35.284 12.0151 35.5599 13.0152C35.6979 13.498 35.9738 13.8084 36.3186 13.9118L24.4898 10.8081Z",
    fill: "url(#paint7_linear_8389_16253)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5944 13.0496C35.3185 12.0495 35.6633 10.6011 36.422 9.84242C37.1807 9.08371 38.0084 9.29063 38.2843 10.2907C38.5602 11.2908 38.2153 12.7393 37.4566 13.498C36.6979 14.2567 35.8703 14.0498 35.5944 13.0496Z",
    fill: "#617AF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.0763 4.91073C20.2143 4.39343 17.5243 3.15192 14.0412 2.15182C10.5581 1.15171 7.59224 0.806849 7.4543 1.32414C7.31635 1.84144 10.0063 3.08295 13.4894 4.08306C16.9725 5.08316 19.9384 5.46251 20.0763 4.91073Z",
    fill: "url(#paint8_linear_8389_16253)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.664 17.1184C53.0092 15.0837 52.0091 10.9799 51.5952 9.80732C50.1468 5.32409 47.112 2.73762 44.7325 2.11686C42.9392 1.66854 41.6632 2.35826 41.2148 2.59967C42.2839 1.97891 43.7668 2.08237 45.4222 3.0135C48.6984 4.91025 51.3538 9.53143 51.3538 13.2904C51.3883 15.1872 50.7331 16.4977 49.664 17.1184Z",
    fill: "#5771F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1461 13.4283C51.1461 9.63481 48.4907 5.04813 45.2145 3.15138C43.5591 2.18576 42.0417 2.11678 40.9727 2.73754L41.2141 2.59959C42.2831 1.97884 43.8005 2.04781 45.4559 3.01343C48.7321 4.91018 51.3875 9.53136 51.3875 13.2904C51.3875 15.1526 50.7323 16.4976 49.6632 17.1184L49.4218 17.2563C50.4909 16.6356 51.1461 15.3251 51.1461 13.4283Z",
    fill: "#617AF7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2158 3.15162C43.5605 2.186 42.0431 2.11702 40.974 2.73778C38.8703 4.01377 38.1461 6.28987 38.8703 9.46262C39.0428 10.2903 40.1808 14.4976 44.2157 17.0151C45.5952 17.7738 47.3195 18.3946 49.4232 17.2221C50.4922 16.6013 51.1475 15.2908 51.1475 13.3941C51.1475 9.66954 48.492 5.04837 45.2158 3.15162Z",
    fill: "url(#paint9_linear_8389_16253)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1826 16.9122C47.2174 18.671 49.7004 17.257 49.7004 13.7739C49.7004 10.2908 47.2518 6.01446 44.217 4.25565C41.1822 2.49684 38.6992 3.91078 38.6992 7.39391C38.6992 10.9115 41.1477 15.1533 44.1826 16.9122Z",
    fill: "#617AF7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1802 22.774C34.387 23.3258 33.2834 23.2913 32.0075 22.5671C29.6624 21.2222 27.7656 17.946 27.7656 15.2215C27.7656 13.8766 28.2484 12.9454 29.0071 12.4971L40.6635 5.77226C41.4222 5.32394 42.4913 5.39292 43.6983 6.08264C46.0434 7.42761 47.9402 10.7038 47.9402 13.3938C47.9402 14.7387 47.4574 15.6699 46.6987 16.1182L35.0423 22.8775C35.1112 22.843 35.1457 22.8085 35.1802 22.774Z",
    fill: "url(#paint10_linear_8389_16253)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4218 25.3596C38.767 23.325 37.7669 19.2211 37.3531 18.0485C35.9046 13.5653 32.8698 10.9788 30.4903 10.3581C28.697 9.90975 27.421 10.5995 26.9727 10.8409C28.0417 10.2201 29.5246 10.3236 31.18 11.2547C34.4562 13.1515 37.1116 17.7726 37.1116 21.5317C37.1461 23.3939 36.4909 24.7044 35.4218 25.3596Z",
    fill: "#5771F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.904 21.6705C36.904 17.877 34.2485 13.2903 30.9723 11.3936C29.3169 10.4279 27.7995 10.359 26.7305 10.9797L26.9719 10.8418C28.041 10.221 29.5584 10.29 31.2137 11.2556C34.4899 13.1524 37.1454 17.7735 37.1454 21.5326C37.1454 23.3948 36.4901 24.7398 35.421 25.3605L35.1796 25.4985C36.2487 24.8777 36.904 23.5328 36.904 21.6705Z",
    fill: "#617AF7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.181 25.4978C36.25 24.877 36.9053 23.5665 36.9053 21.6698C36.9053 17.8763 34.2498 13.2896 30.9736 11.3928C29.3183 10.4272 27.8009 10.3582 26.7318 10.979C24.6281 12.255 23.9039 14.5311 24.6281 17.7038C24.8006 18.5315 25.9386 22.7388 29.9735 25.2564C31.353 26.0151 33.1118 26.6358 35.181 25.4978Z",
    fill: "url(#paint11_linear_8389_16253)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9368 25.1187C32.9716 26.8775 35.4546 25.4636 35.4546 21.9804C35.4546 18.4973 33.0061 14.221 29.9713 12.4622C26.9365 10.7034 24.4535 12.1173 24.4535 15.6005C24.419 19.1181 26.902 23.3944 29.9368 25.1187Z",
    fill: "#617AF7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2825 21.0153C39.0412 20.567 39.5241 19.6359 39.5241 18.2909C39.5241 15.601 37.6273 12.3248 35.2822 10.9798C34.1442 10.3246 33.0751 10.2556 32.3164 10.6694L37.8687 7.46221C38.6274 7.01388 39.6965 7.08285 40.9035 7.77258C43.2486 9.11755 45.1453 12.3938 45.1453 15.0837C45.1453 16.4287 44.6625 17.3598 43.9038 17.8081L38.2825 21.0153Z",
    fill: "url(#paint12_linear_8389_16253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8389_16253",
    x1: 23.9432,
    y1: 29.785,
    x2: 56.4802,
    y2: 29.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2947DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8389_16253",
    x1: 27.2894,
    y1: 28.6763,
    x2: 50.5647,
    y2: 28.6763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1442,
    stopColor: "#DB9E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F2BC21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3559,
    stopColor: "#FAC826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    stopColor: "#F9C625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3959,
    stopColor: "#F5BF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4035,
    stopColor: "#EEB418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4096,
    stopColor: "#E3A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4142,
    stopColor: "#D89000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4408,
    stopColor: "#DC980D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#EBB53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6568,
    stopColor: "#F6CB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7383,
    stopColor: "#FDD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7902,
    stopColor: "#FFDD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    stopColor: "#FEDB77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8613,
    stopColor: "#FDD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#FBCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9617,
    stopColor: "#FAC92B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8389_16253",
    x1: 24.7144,
    y1: 22.8808,
    x2: 55.7114,
    y2: 22.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C55D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8389_16253",
    x1: 25.1868,
    y1: 21.469,
    x2: 55.2519,
    y2: 21.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#5068DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8389_16253",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.18384 5.23694) rotate(45) scale(5.39886)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3214,
    stopColor: "#1E3AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5204,
    stopColor: "#1634CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#617AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8389_16253",
    x1: 11.225,
    y1: 8.71019,
    x2: 13.1222,
    y2: 1.62997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    stopColor: "#4B64E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#314EE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8389_16253",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5515 11.3188) rotate(45) scale(7.35974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3214,
    stopColor: "#3047BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5204,
    stopColor: "#233DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2037A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8389_16253",
    x1: 29.7505,
    y1: 12.2299,
    x2: 30.9796,
    y2: 7.64277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    stopColor: "#4560E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3855E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8389_16253",
    x1: 7.45454,
    y1: 1.35009,
    x2: 20.0761,
    y2: 4.92481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8389_16253",
    x1: 40.588,
    y1: 12.9927,
    x2: 49.0681,
    y2: 7.49048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4762E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#2B4AE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#617AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8389_16253",
    x1: 34.8289,
    y1: 9.07274,
    x2: 40.8193,
    y2: 19.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4745,
    stopColor: "#879AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324EDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8389_16253",
    x1: 26.1473,
    y1: 21.1863,
    x2: 34.4148,
    y2: 16.0921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#314DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8389_16253",
    x1: 36.5453,
    y1: 8.08103,
    x2: 42.533,
    y2: 18.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382764,
    stopColor: "#FAC92B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859864,
    stopColor: "#FBCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1387,
    stopColor: "#FDD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#FEDB77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2098,
    stopColor: "#FFDD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#FDD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3432,
    stopColor: "#F6CB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#EBB53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5592,
    stopColor: "#DC980D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5858,
    stopColor: "#D89000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#E3A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5965,
    stopColor: "#EEB418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    stopColor: "#F5BF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6147,
    stopColor: "#F9C625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    stopColor: "#FAC826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F2BC21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#DB9E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctions);
export default __webpack_public_path__ + "static/media/auctions.382086d51d6c3775975c148c21a61c50.svg";
export { ForwardRef as ReactComponent };